if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

(() => {
    const check = () => {
        const container = document.querySelector('[data-parallax-container]');
        const child = document.querySelector('[data-parallax-child]');

        if (container && child) {
            const offset = container.getBoundingClientRect().top;

            child.style.transform = `translateY(${offset * -.25}px)`;
        }

        window.requestAnimationFrame(check);
    };

    window.requestAnimationFrame(check);
})();

(() => {
    const pageHeaderBackground = document.querySelector('[data-page-header-background]');
    if (pageHeaderBackground) {
        const check = () => {
            pageHeaderBackground.style.transform = `translateY(${window.pageYOffset * .35}px)`;

            window.requestAnimationFrame(check);
        };

        window.requestAnimationFrame(check);
    }
})();
